import React from 'react';
import { connect } from 'react-redux';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { copyTextToClipboard } from 'apps/auth/helpers/utils';

const LibreHistoryModal = (props) => {
    const getMessageForSnackBar = (title, copied) => {
        return `${title} ${copied}`;
    };

    const copyButtonClick = (textToCopy, messageSnackBar) => {
        return () => {
            const result = copyTextToClipboard(textToCopy);
            if (result) {
                props.toggleSnackBar(true, messageSnackBar);
            }
        };
    };

    const getUrl = (addProtocol = false) => {
        let url = __isBrowser__ ? (addProtocol ? location.protocol + '//' : '') + location.hostname + (location.port ? ':' + location.port : '') : '';
        url += '/l-' + props.cheque.toBankAlias;
        return url;
    };

    return (
        <ModalComponent>
            <HeaderPanel title={props.remindRecipientTitle} subtitle={props.cheque.libreTitleDetails} />
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={props.libreDeliveryLabel}
                    detailsText={getUrl()}
                    detailsButton={props.notifyCopyCode}
                    detailsButtonClick={copyButtonClick(getUrl(), getMessageForSnackBar(props.libreDeliveryLabel, props.copied))}
                />
            </Row>
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        remindRecipientTitle: state.messages.pageMessages.remindRecipientButton,
        notifyCopyCode: state.messages.pageMessages.interacNotifyCopyCode,
        libreDeliveryLabel: state.messages.pageMessages.libreDeliveryLabel,
        copied: state.messages.pageMessages.copied,
    };
};
export default connect(mapStateToProps, { toggleSnackBar })(LibreHistoryModal);
